var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0263673 6.20725C0.0263672 6.67669 0.406925 7.05725 0.876367 7.05725L14.1538 7.05725C14.6232 7.05725 15.0038 6.67669 15.0038 6.20725C15.0038 5.73781 14.6232 5.35725 14.1538 5.35725L0.876367 5.35725C0.406925 5.35725 0.0263674 5.73781 0.0263673 6.20725Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2366 11.7874C10.5686 12.1193 11.1067 12.1193 11.4387 11.7874L15.7335 7.49254C16.456 6.77007 16.456 5.59871 15.7335 4.87624L11.4584 0.60107C11.1264 0.269124 10.5882 0.269124 10.2563 0.60107C9.92434 0.933015 9.92434 1.47121 10.2563 1.80315L14.5315 6.07832C14.59 6.1369 14.59 6.23188 14.5315 6.29045L10.2366 10.5853C9.90466 10.9173 9.90466 11.4554 10.2366 11.7874Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon_arrow.1f18180f62994d7ea6de701d3b93b6d6.svg";
export { ForwardRef as ReactComponent };